export const DEBUG = 'debug';
export const TEST = 'test';
export const FEATURE = 'test-feature';
export const UAT = 'test-uat';
export const VERIFY = 'verify';
export const PRODUCTION = 'production';
